module.exports = __webpack_public_path__ + "static/media/img_dance14.53e3a092.png";